import { render } from "./FilterGroup.vue?vue&type=template&id=616b879a&scoped=true"
import script from "./FilterGroup.vue?vue&type=script&lang=js"
export * from "./FilterGroup.vue?vue&type=script&lang=js"

import "./FilterGroup.vue?vue&type=style&index=0&id=616b879a&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616b879a"]])

export default __exports__